@import "../../../global/gx-ide-mixins.scss";
@import "../../../global/temporary-mercury-overrides/_button.scss";
@import "../../../../node_modules/@genexus/mercury/dist/assets/scss/helpers.scss";
@import "../common/styles.scss";

:host {
  display: grid;
  block-size: 100%;
  grid-template-rows: max-content max-content 1fr max-content;
  row-gap: var(--spacing-gap-xl);
  overflow: auto;
}

:host(.new-connection) {
  grid-template-rows: max-content 1fr;
}

:host(.recently-used-empty) {
  grid-template-rows: max-content 1fr;
}

.section {
  display: contents;
}

// General

ch-tabular-grid.tabular-grid {
  border-radius: 4px;
  overflow: hidden;
  overflow: auto;
  border: 1px solid var(--color-border-surface-on-elevation-1); // WA: The tabular-grid should provide a class for displaying border
}

ch-tabular-grid-rowset-empty {
  position: relative;
  border-block-end: 1px solid var(--grid-cell-border-color);
  overflow: hidden;
  min-block-size: 200px;
}

@include tabular-grid-cell-layout(
  $tabular-grid-selector: ".tabular-grid",
  $tabular-grid-cell-apply-ellipsis: true,
  $tabular-grid-affected-columns-nth-list: (
    2,
    3,
    4
  )
);

.text-neutral-gray-400,
.tabular-grid-cell.text-neutral-gray-400 {
  // WA: colors for text should be defined in Mercury
  color: var(--color-text-neutral-disabled);
}
// Header

.search-server {
  inline-size: 50%;
}

// All Servers

.tabular-grid {
  overflow: auto;
  border-block: 1px solid var(--grid-cell-border-color);
}

.tabular-grid-all-servers .tabular-grid-column:first-child::part(bar) {
  --grid-common__gap: 0;
}

.field-block-all-servers {
  overflow: auto;
}

// WA: .tabular-grid-wrapper and .border-patch is a WA. See details on Asana task:
// https://app.asana.com/1/10206720691358/project/1207081021030105/task/1211391456974726?focus=true
.tabular-grid-wrapper {
  position: relative;
  overflow: auto;
}
.border-patch {
  --tabular-grid-border-radius: 4px;
  position: absolute;
  inset-block-start: 0;
  inline-size: calc(100% - var(--tabular-grid-border-radius) * 2);
  inset-inline-start: var(--tabular-grid-border-radius);
  block-size: 2px;
  background-color: var(--items-container__bg-color);
  z-index: 9999;
  border-block-start: 1px solid var(--color-border-surface-on-surface);
}

.tooltip {
  position: absolute;
}

.recently-used-card {
  border: 1px solid var(--color-border-surface-on-elevation-1);
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background-color: var(--color-accent-item-hover);
  }

  &:focus-visible {
    @include focus-outline();
  }

  &--selected {
    background-color: var(--color-accent-neutral-contrast);
    border-color: var(--color-border-item-pressed);
  }
}

.recently-used-card-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: var(--spacing-padding-m);
  gap: var(--spacing-gap-xxs);
  overflow: hidden;

  .text-decoration-line-underline {
    @include cell-ellipsis();
    max-width: 100%;
    text-decoration: underline;
  }
}

// All Severs tabular-grid

.delete-server-icon {
  // WA: Getr and apply the marign inline value on the ch-image,
  // so that the button looks squared. This happens because the
  // button is "tertiary", which happens to have no padding-inline.
  // TODO: Investigate a solution that works without a WA.
  $cellBlockSize: 30.39px;
  margin-inline: calc((#{$cellBlockSize} - var(--ch-image-size)) / 2);
}

@include tabular-grid-cell-layout(
  $tabular-grid-selector: ".tabular-grid",
  $tabular-grid-cell-node-type: "element",
  $tabular-grid-affected-columns-nth-list: (
    5
  )
);
